import {
  PlanRecommendationsResponse,
  PlanSelectionRequest,
  PlanSelectionResponse,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import { recommendPlanTags } from './tags';
import { RecommendPlanEndpoints } from './types';
import {
  GET_RECOMMEND_PLAN_STATUS,
  PLAN_RECOMMENDATIONS,
  UPDATE_PLAN_RECOMMEND_STATUS,
} from './urls';

export const recommendPlanApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [recommendPlanTags.recommendPlanStatus],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [RecommendPlanEndpoints.getRecommendPlanStatus]: builder.query<
        PlanSelectionResponse,
        void
      >({
        query: () => ({
          method: 'GET',
          url: GET_RECOMMEND_PLAN_STATUS,
        }),
        providesTags: [recommendPlanTags.recommendPlanStatus],
      }),
      [RecommendPlanEndpoints.getPlanRecommendations]: builder.query<
        PlanRecommendationsResponse,
        void
      >({
        query: () => ({
          method: 'GET',
          url: PLAN_RECOMMENDATIONS,
        }),
        providesTags: [recommendPlanTags.recommendPlanStatus],
      }),
      [RecommendPlanEndpoints.updateRecommendPlanStatus]: builder.mutation<
        void,
        PlanSelectionRequest
      >({
        query: (payload) => ({
          method: 'POST',
          url: UPDATE_PLAN_RECOMMEND_STATUS,
          data: payload,
        }),
      }),
    }),
  });

export const {
  useGetPlanRecommendationsQuery,
  useLazyGetPlanRecommendationsQuery,
  useUpdateRecommendPlanStatusMutation,
  useGetRecommendPlanStatusQuery,
  useLazyGetRecommendPlanStatusQuery,
} = recommendPlanApi;
